import { createSlice } from "@reduxjs/toolkit";
import LOCALE_FILTERS_PROPERTIES, {
  I_LOCALE_FILTERS_PROPERTIES
} from "./util/filters.util";
import ConvertToServerFiltersProperty from "./adapters/ConvertToServerFiltersProperty";
import HelperRemoveNullValues from "@/src-refactor/modules/shared/helpers/remove-null-values.helper";

const initialState: initialStatePropertyFilter = {
  localeFilters: LOCALE_FILTERS_PROPERTIES,
  serverFilters: {},
  scrollPosition: 0,
  count: 0
};
export interface initialStatePropertyFilter {
  localeFilters: I_LOCALE_FILTERS_PROPERTIES;
  serverFilters: any;
  scrollPosition: number;
  count: number;
}

export const PropertyFilterSlice = createSlice({
  name: "property-list-slices-rf",
  initialState: initialState,
  reducers: {
    setFilters: (state, action) => {
      const data = { ...LOCALE_FILTERS_PROPERTIES, ...action.payload };
      const clearItems = HelperRemoveNullValues(data);
      state.localeFilters = {
        ...LOCALE_FILTERS_PROPERTIES,
        ...action.payload
      };
      state.serverFilters = ConvertToServerFiltersProperty(clearItems);
      state.scrollPosition = 0;

      const filtersUses = Object.keys(
        HelperRemoveNullValues(clearItems, {
          removeEmptyArray: true,
          removeEmptyStrings: true,
          removeBoleanFalse: true
        })
      ).filter(
        key =>
          ![
            "currency_price_property",
            "maintenance_currency_property",
            "page"
          ].includes(key)
      );

      state.count = filtersUses.length;
    },
    setScrollPosition: (state, action) => {
      state.scrollPosition = action.payload;
    },
    clearFilter: state => {
      state.localeFilters = LOCALE_FILTERS_PROPERTIES;
      state.serverFilters = {};
      state.scrollPosition = 0;
      state.count = 0;
    }
  }
});
